import { Suspense } from "react";
import MXLoading from "./MXLoading";

export default function MatxSuspense({ children }) {
  return <Suspense fallback={<MXLoading />}>{children}</Suspense>;
}
